// extracted by mini-css-extract-plugin
module.exports = {"tooltip-trigger":"cd01fbf7b5--tooltip-trigger--hQ95G"};